import React from 'react';
import { FormSection, FieldArray } from 'redux-form';

import OrSelector from './OrSelector';
import RenderAssetArray from './RenderAssetArray';
import RenderOrArray from './RenderOrArray';
import MapAssetFields from './MapAssetFields';

import Column from './Column';
import { Row } from 'react-bootstrap';

const AssetSection = ({ asset, readOnly }) => {
  const {
    fields,
    isRoot,
    opts
  } = asset || {};
  const {
    name,
    label,
    isArray,
    isOr
  } = opts || {}
  if (!asset) return false;

  if (isRoot) return <MapAssetFields asset={asset} readOnly={readOnly} />


  if (isOr && isArray) return (
    <FieldArray name={name} component={RenderOrArray} props={{ asset, readOnly }} />
  )

  if (isArray) return (
    <FieldArray name={name} component={RenderAssetArray} props={{ asset, readOnly }} />
  )

  if (isOr) return (
    <OrSelector asset={asset} readOnly={readOnly} />
  )

  return (
    <FormSection name={name}>
      <Column field={asset}>
        <h5>{asset.opts.label}</h5>
        <Row>
          <MapAssetFields asset={asset} readOnly={readOnly} />
        </Row>
      </Column>
    </FormSection>
  )
}

export default AssetSection;



// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/AssetSection.js